import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PrimaryHeading from "../../../../components/@ui/headings/PrimaryHeading";
import useBreakpoint from "../../../../hooks/useBreakpoint";
import PriseenLogo from "../../../../components/@extended/logos/PriseenLogo";
import HeroImage from "./HeroImage";

const content = {
  title: "Priseen",
  description:
    "With a moto of Technology for Everyone, to offer a diversified portfolio of tech solutions that provide 360-degree coverage across the Tech, Retail, and F&B industries. Our mission is to make innovation accessible, regardless of social status.",
  image: "assets/images/hero-images/phone-frame.png",
  map: "assets/images/hero-images/circle-map.png",
  catalogue: "assets/images/hero-images/catalogue.png",
};

const circleSizes = {
  small:
    "lg:w-[350px] lg:h-[350px] md:w-[300px] lg:h-[300px] w-[150px] h-[150px]",
  medium:
    "lg:w-[450px] lg:h-[450px]  md:w-[375px] md:h-[375px] w-[250px] h-[250px]",
  large:
    "lg:w-[550px] lg:h-[550px]  md:w-[450px] md:h-[450px] w-[300px] h-[300px]",
};

const Hero = () => {
  const breakpoint = useBreakpoint();
  const large = ["xl", "lg", "sm"].includes(breakpoint);

  const handleScroll = () => {
    const section = document.getElementById("contact-section");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box className="p-[10px]">
      <Box
        component="section"
        id="hero-section"
        className="section-container relative min-h-[700px] lg:min-h-[700px] md:min-h-[450px] overflow-hidden border-solid border-primary border"
        sx={{
          border: "1px solid",
          borderRadius: "8px",
        }}
      >
        {/* Content */}
        <div className="section-content-container flex items-center md:flex-row lg:flex-row flex-col justify-center duration-1000 lg:space-y-0 md:space-y-0 space-y-10 sm:gap-[8px] md:gap-12 lg:gap-16 z-[21]">
          {/* Text Content */}
          <Box className={`flex-1 space-y-8`}>
            {/* <PrimaryHeading size="large">{content.title}</PrimaryHeading> */}
            <PriseenLogo width={large ? 260 : 200} />

            <Typography className="md:text-[18px] lg:text-[22px] whitespace-pre-line text-primary">
              Seamless experiences, smarter interactions, and sustainable
              solutions—shaping the future of business-consumer engagement.
            </Typography>

            <Button
              className="text-white bg-black gap-2 lg:w-[320px] w-[250px]"
              onClick={handleScroll}
            >
              {"Connect with us"} <ArrowForwardIcon sx={{ fontSize: "20px" }} />
            </Button>
          </Box>

          {/* Image Container */}
          <HeroImage
            src={content.image}
            alt={content.title}
            map={content.map}
            catalogue={content.catalogue}
          />
        </div>

        {/* Blur Overlay */}
        <div className="absolute z-[20] bg-white/[0.2] lg:min-h-[700px] h-full w-full backdrop-blur-[100px]"></div>

        {/* Circle 1 */}
        <div
          className={`absolute -bottom-[70px] -left-[150px] ${circleSizes.small} rounded-full backdrop-blur-[10px] bg-teal-400/[0.3]`}
        ></div>

        {/* Circle 2 */}
        <div
          className={`absolute -bottom-[70px] -left-[150px] ${circleSizes.large} rounded-full backdrop-blur-[10px] bg-sky-400/[0.3]`}
        ></div>

        {/* Circle 3 */}
        <div
          className={`absolute -bottom-[70px] -right-[150px] ${circleSizes.small}rounded-full backdrop-blur-[10px] bg-teal-400/[0.3]`}
        ></div>

        {/* Circle 4 */}
        <div
          className={`absolute -bottom-[70px] -right-[150px] ${circleSizes.medium} rounded-full backdrop-blur-[10px] bg-cyan-400/[0.2]`}
        ></div>

        {/* Circle 5 */}
        <div
          className={`absolute -bottom-[70px] -right-[150px] ${circleSizes.large} rounded-full backdrop-blur-[10px] bg-sky-400/[0.2]`}
        ></div>

        {/* Circle 6 */}
        <div
          className={`absolute -bottom-[100px] left-1/2 transform -translate-x-1/2 ${circleSizes.medium} rounded-full backdrop-blur-[10px] bg-teal-400/[0.4]`}
        ></div>

        {/* Circle 7 */}
        <div
          className={`absolute -bottom-[70px] left-1/4 transform ${circleSizes.small} rounded-full backdrop-blur-[10px] bg-teal-400/[0.3]`}
        ></div>
        {/* Circle 8 */}
        <div
          className={`absolute -bottom-[70px] right-1/4 transform ${circleSizes.small} rounded-full backdrop-blur-[10px] bg-cyan-400/[0.3]`}
        ></div>

        {/*  */}
      </Box>
      {/* <Box className="section-content-container items-center justify-center flex bg-blue-200 m-[10px] rounded-[8px] min-h-[100px] h-full`}>
        <style>{customAnimations}</style>
      </Box> */}
    </Box>
  );
};

export default Hero;
